export default __webpack_public_path__ + "static/media/Email.ab203b7d.svg";